// =============================================================
// types.ts — 지갑 어댑터 공용 인터페이스
//   injected.ts / reown.ts 가 동일하게 구현한다.
// =============================================================

import type { BrowserProvider } from 'ethers';

export type SdkErrorCode = 'NO_WALLET' | 'USER_REJECTED' | 'WRONG_CHAIN' | 'TIMEOUT' | 'UNKNOWN';

export class SdkError extends Error {
  code: SdkErrorCode;
  constructor(code: SdkErrorCode, message?: string) {
    super(message ?? code);
    this.code = code;
    this.name = 'SdkError';
  }
}

export interface WalletSnapshot {
  connected: boolean;
  address: string | null;
  short: string | null;
  chainOk: boolean;
}

export interface WalletAdapter {
  connect(): Promise<string>;
  restore(): Promise<void>;
  disconnect(): Promise<void>;
  getProvider(): Promise<BrowserProvider>;
  getAddress(): string | null;
  ensureChain(): Promise<void>;
  onChange(cb: (s: WalletSnapshot) => void): () => void;
  snapshot(): WalletSnapshot;
}